/** Browser-only navigation state, never booking authority.
 * The server revalidates the customer session, public booking rules and room.
 * TTL avoids silently resuming an old room/time after a subsequent visit.
 */
export type PendingGuestBooking={
  location:string;service:string;date:string;roomCode:string;startsAt:string;
  savedAt:number;
};
const storageKey='ecfs.public.pendingBooking.v1';
const ttl=15*60*1000;
export function readPendingGuestBooking():PendingGuestBooking|null{
  try{
    const saved=window.sessionStorage.getItem(storageKey);
    if(!saved)return null;
    const data=JSON.parse(saved) as PendingGuestBooking;
    if(!data||!Number.isFinite(data.savedAt)||Date.now()-data.savedAt>ttl||
      data.savedAt>Date.now()+60000||
      !/^[A-Z0-9_-]{2,64}$/.test(data.location)||
      !/^[A-Z0-9_-]{2,64}$/.test(data.service)||
      !/^[A-Z0-9_-]{1,64}$/.test(data.roomCode)||
      !/^\d{4}-\d{2}-\d{2}$/.test(data.date)||
      Number.isNaN(Date.parse(data.startsAt))||
      Date.parse(data.startsAt)<=Date.now()){
      window.sessionStorage.removeItem(storageKey);
      return null;
    }
    return data;
  }catch{return null;}
}
export function savePendingGuestBooking(input:Omit<PendingGuestBooking,'savedAt'>){
  try{window.sessionStorage.setItem(storageKey,JSON.stringify({
    ...input,savedAt:Date.now(),
  }));}catch{/* preserve working navigation when storage is unavailable */}
}
export function clearPendingGuestBooking(){
  try{window.sessionStorage.removeItem(storageKey);}catch{/* no storage */}
}
